<template>
  <router-view class="fill-height" />
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
